export const UMB_DATA_TYPE_ITEM_REPOSITORY_ALIAS = 'Umb.Repository.DataType.Item';
export const UMB_DATA_TYPE_STORE_ALIAS = 'Umb.Store.DataType.Item';
export { UMB_DATA_TYPE_ITEM_STORE_CONTEXT } from './data-type-item.store.context-token.js';
